import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Trash2, UserPlus } from "lucide-react";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";

export const StaffMembers = ({ church }) => {
  const [list, setList] = useState([]);
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("admin");
  const owner = church.role === "owner";
  const load = useCallback(() => api.get("/members").then((r) => setList(r.data)), []);
  useEffect(() => { load(); }, [load]);

  const invite = async (e) => {
    e.preventDefault();
    try {
      await api.post("/members", { email, role });
      toast.success(`Invite sent to ${email}`);
      setEmail("");
      load();
    } catch (err) {
      toast.error(err.response?.data?.detail?.[0]?.msg || err.response?.data?.detail || "Could not invite");
    }
  };
  const remove = async (m) => { await api.delete(`/members/${encodeURIComponent(m.email)}`); toast.success("Access removed"); load(); };

  return (
    <section className="card-soft p-8 md:p-10 mt-6" data-testid="staff-section">
      <p className="font-display text-navy text-lg font-semibold">Staff logins</p>
      <p className="text-sm text-muted-ink mt-1">Invite team members with their own Google sign-in. Admins can edit everything; view-only members can only look.</p>
      {owner && (
        <form onSubmit={invite} className="flex flex-wrap gap-3 mt-6">
          <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="name@church.org" className="h-11 flex-1 min-w-[200px]" data-testid="staff-email-input" />
          <select value={role} onChange={(e) => setRole(e.target.value)} className="h-11 rounded-lg border border-line px-3 bg-white text-navy" data-testid="staff-role-select">
            <option value="admin">Admin</option>
            <option value="viewer">View-only</option>
          </select>
          <button className="btn-navy !py-2 flex items-center gap-2" data-testid="staff-invite-btn"><UserPlus size={16} /> Invite</button>
        </form>
      )}
      <div className="divide-y divide-[var(--line)] mt-5">
        {list.map((m) => (
          <div key={m.email} className="flex items-center justify-between py-3" data-testid={`staff-row-${m.email}`}>
            <span className="text-navy">{m.email}</span>
            <div className="flex items-center gap-4">
              <span className="text-xs bg-teal-soft text-teal rounded-full px-3 py-1">{m.role === "admin" ? "Admin" : "View-only"}</span>
              {owner && <button onClick={() => remove(m)} className="text-red-700" aria-label="Remove" data-testid={`staff-remove-${m.email}`}><Trash2 size={15} /></button>}
            </div>
          </div>
        ))}
        {list.length === 0 && <p className="text-sm text-muted-ink py-3">No staff invited yet.</p>}
      </div>
    </section>
  );
};
